var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInatividadeContato({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 12.4444H1.55556V1.55556H12.4444M12.4444 0H1.55556C1.143 0 0.747335 0.163888 0.455612 0.455612C0.163888 0.747335 0 1.143 0 1.55556V12.4444C0 12.857 0.163888 13.2527 0.455612 13.5444C0.747335 13.8361 1.143 14 1.55556 14H12.4444C12.857 14 13.2527 13.8361 13.5444 13.5444C13.8361 13.2527 14 12.857 14 12.4444V1.55556C14 0.692222 13.3 0 12.4444 0ZM10.5 10.3056C10.5 9.13889 8.16667 8.55556 7 8.55556C5.83333 8.55556 3.5 9.13889 3.5 10.3056V10.8889H10.5M7 7.19444C7.46413 7.19444 7.90925 7.01007 8.23744 6.68188C8.56563 6.35369 8.75 5.90857 8.75 5.44444C8.75 4.98032 8.56563 4.5352 8.23744 4.20701C7.90925 3.87882 7.46413 3.69444 7 3.69444C6.53587 3.69444 6.09075 3.87882 5.76256 4.20701C5.43437 4.5352 5.25 4.98032 5.25 5.44444C5.25 5.90857 5.43437 6.35369 5.76256 6.68188C6.09075 7.01007 6.53587 7.19444 7 7.19444Z",
    fill: "#E93F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInatividadeContato);
export default __webpack_public_path__ + "static/media/inatividade-contato.73147708.svg";
export { ForwardRef as ReactComponent };